import React from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import KpiNumberTile from "./KpiNumberTile";
import { nv, periodDelta } from "./utils";
import { useTrendsData } from "./hooks/useTrendsData";

const pick = (s) => (s.statusCodeStats?.http4xxCount ?? 0) + (s.statusCodeStats?.http5xxCount ?? 0);

export default function KpiErrorsTile({ startDate, endDate, lastN, onFilter, onInvestigate }) {
    const { workspaceNumber } = useParams();
    const live = useSelector((s) => s.stats?.workspaceStats);
    const { series, days } = useTrendsData({ workspaceNumber, startDate, endDate, lastN });

    const value = pick(live || {});
    const c4xx = Number(live?.statusCodeStats?.http4xxCount ?? 0);
    const c5xx = Number(live?.statusCodeStats?.http5xxCount ?? 0);

    return (
        <KpiNumberTile
            title="Errors"
            info="Pages returning 4xx or 5xx right now. Fewer is better — down = good. Change compares against the start of the selected period."
            tone={value > 0 ? "#dc2626" : undefined}
            sparkColor="#dc2626"
            value={live?.fetched ? value : "—"}
            valueTooltip={live?.fetched ? `4xx: ${nv(c4xx)} • 5xx: ${nv(c5xx)}` : undefined}
            delta={periodDelta(value, days, pick)}
            sparkSeries={series(pick)}
            onFilter={onFilter}
            onInvestigate={onInvestigate}
        />
    );
}
